export enum ShapeTypes {
  DESIGN_SHAPE = 'DesignShape',
  PLACE_SHAPE = 'PlaceShape',
  SECTOR_SHAPE = 'SectorShape',
  NONE = 'None'
}
